import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { chartLineStyles } from '../Common/ChartUtils';
import { chartLineColors, reasonKeyToContent } from './FeedbackReports.constants';
import { headerConfigByFilter } from './FeedbackReportsHead';
import FeedbackReportsTableContent from './FeedbackReportsTableContent';
export const getElements = (series, seriesName) => {
  var _series$find$elements, _series$find;
  return (_series$find$elements = (_series$find = series.find(item => item.name === seriesName)) === null || _series$find === void 0 ? void 0 : _series$find.elements) !== null && _series$find$elements !== void 0 ? _series$find$elements : [];
};
export const calculateTotalCount = elements => elements.reduce((total, current) => current.count + total, 0);
export const getHeaderConfig = (reportBy, source) => headerConfigByFilter[reportBy] || headerConfigByFilter[source];
export const getColumns = function getColumns(series, reportBy, reasonCategory) {
  let isSummaryContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let appKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  return getHeaderConfig(reportBy, reasonCategory).map(reasonKey => {
    const elements = getElements(series, reasonKey);
    const value = calculateTotalCount(elements);
    return {
      value,
      key: value,
      content: /*#__PURE__*/React.createElement(FeedbackReportsTableContent, {
        appKey: appKey,
        feedbackCount: value,
        reportBy: reportBy,
        reasonKey: reasonKey,
        isSummaryContent: isSummaryContent
      })
    };
  });
};

/*
 Returns array of feedback keys with their respective counts in desc order of their count
 */
export const getFeedbackReasonsSortedByCount = (series, reportBy, source) => {
  const configs = getHeaderConfig(reportBy, source).map(reasonKey => {
    const elements = getElements(series, reasonKey);
    const count = calculateTotalCount(elements);
    return {
      key: reasonKey,
      count
    };
  });
  return configs.sort((line1, line2) => line1.count < line2.count ? 1 : -1);
};
export const getReportColumnsForSeries = function getReportColumnsForSeries(series, reportBy, source) {
  let isSummaryContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let appKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  const columns = getColumns(series, reportBy, source, isSummaryContent, appKey);
  const total = columns.reduce((newTotal, cell) => newTotal + cell.value, 0);
  return [...columns, {
    key: total,
    value: total,
    content: /*#__PURE__*/React.createElement(FeedbackReportsTableContent, {
      appKey: appKey,
      feedbackCount: total,
      reportBy: reportBy,
      isSummaryContent: isSummaryContent
    })
  }];
};
export const getFeedbackReportTableData = (reportApps, reportBy, source, allReportingApps) => {
  const tableData = reportApps.map(app => ({
    appKey: app.addonKey,
    appName: app.name,
    columns: getReportColumnsForSeries(app.series, reportBy, source, false, app.addonKey)
  }));
  allReportingApps.forEach(app => {
    if (!tableData.some(entry => entry.appKey === app.appKey)) {
      tableData.push({
        appKey: app.appKey,
        appName: app.appName,
        columns: getReportColumnsForSeries([], reportBy, source, false, app.appKey)
      });
    }
  });
  return tableData;
};
export const getLines = (headerConfig, lineConfigState, enableReportsAccessibilityChanges) => headerConfig.map((reasonKey, index) => ({
  color: enableReportsAccessibilityChanges ? chartLineStyles[index].color : chartLineColors[index].color,
  dataKey: reasonKey,
  legend: reasonKeyToContent[reasonKey].name,
  dotStyle: enableReportsAccessibilityChanges ? chartLineStyles[index].dotStyle : chartLineColors[index].dotStyle,
  strokeStyle: enableReportsAccessibilityChanges ? chartLineStyles[index].strokeStyle : chartLineColors[index].strokeStyle
})).filter(_ref => {
  let {
    dataKey
  } = _ref;
  return !enableReportsAccessibilityChanges || lineConfigState.has(dataKey);
});
const getFeedbackCountOfReasonByIndex = (totalSeries, reasonKey, index) => {
  const elements = getElements(totalSeries, reasonKey);
  return elements[index] ? elements[index].count : 0;
};
export const getChartData = (totalSeries, headerConfig) => totalSeries[0].elements.map((element, index) => _objectSpread(_objectSpread({}, headerConfig.reduce((prev, reasonKey) => _objectSpread(_objectSpread({}, prev), {}, {
  [reasonKey]: getFeedbackCountOfReasonByIndex(totalSeries, reasonKey, index)
}), {})), {}, {
  xLabel: element.date
}));
const getValueFromPayload = (item, key) => {
  const value = item.payload[key];
  return typeof value === 'number' ? value : 0;
};
export const getChartTooltipPairs = (payload, headerConfig, lines) => {
  const chartedReasonKeys = new Set();
  const chartedTooltipPairs = payload.map((item, index) => {
    chartedReasonKeys.add(item.dataKey);
    return {
      color: item.color,
      label: item.name,
      value: getValueFromPayload(item, item.dataKey),
      isCharted: true,
      dotStyle: lines[index].dotStyle,
      strokeStyle: lines[index].strokeStyle
    };
  });
  const totalFeedback = chartedTooltipPairs.reduce((total, tooltip) => total + tooltip.value, 0);
  const notChartedTooltipPairs = [];
  if (payload.length > 0) {
    const feedbackPerUnit = payload[0];
    headerConfig.filter(key => !chartedReasonKeys.has(key)).forEach(key => {
      notChartedTooltipPairs.push({
        label: reasonKeyToContent[key].name,
        value: getValueFromPayload(feedbackPerUnit, key),
        isCharted: false
      });
    });
  }
  return [...chartedTooltipPairs, ...notChartedTooltipPairs, {
    label: 'All feedback',
    value: totalFeedback
  }];
};

/*
 * This function will return Aggregated feedback series for given app
 * If no app passed, will retutn total series
 */
export const getSeriesByAppName = (feedbackReport, appKey) => {
  if (!feedbackReport) {
    return [];
  }
  if (appKey) {
    const appKeySeries = feedbackReport.addons.find(series => series.addonKey === appKey);
    return appKeySeries ? appKeySeries.series : [];
  }
  return feedbackReport.total.series;
};